import USER_API from 'api/user/v1'
import { startSubmit, stopSubmit, SubmissionError } from 'redux-form'
import { call, put, takeLatest } from 'redux-saga/effects'
import extractErrors from 'utils/extractErrors'
import { notificationShow } from 'modules/Notifications/actions'

function* get2FA() {
  try {
    const { response, error } = yield call(USER_API.check2FA)

    if (error) {
      throw error
    }

    yield put({ type: 'USER/SET_2FA', payload: response.data })
  } catch (error) {
    console.logXHR(error)
  }
}

function* enable2FA({
  payload,
  meta: { resolve = () => {}, reject = () => {} } = {},
}) {
  try {
    yield put(startSubmit(payload.formName))

    const { response, error } = yield call(USER_API.enable2FA, {
      data: payload.data,
    })

    if (error) {
      throw error
    }

    if (response?.status === 200) {
      yield put(
        notificationShow({
          type: 'success',
          message: 'user::security.2fa.enable_form.notifications.success',
          delay: 6000,
        }),
      )
    }

    resolve()
  } catch (error) {
    yield put(stopSubmit(payload.formName, error.errors))
    const { fields } = extractErrors(error.errors)

    fields && reject(new SubmissionError(fields))

    console.logXHR(error)
  }
}

function* disable2FA({
  payload,
  meta: { resolve = () => {}, reject = () => {} } = {},
}) {
  try {
    yield put(startSubmit(payload.formName))

    const { response, error } = yield call(USER_API.disable2FA, {
      data: payload.data,
    })

    if (error) {
      throw error
    }

    if (response?.status === 200) {
      yield put(
        notificationShow({
          type: 'success',
          message: 'user::security.2fa.disable_form.notifications.success',
          delay: 6000,
        }),
      )
    }

    resolve()
  } catch (error) {
    yield put(stopSubmit(payload.formName, error.errors))
    const { fields } = extractErrors(error.errors)

    fields && reject(new SubmissionError(fields))

    console.logXHR(error)
  }
}

function* init2FA({ meta: { resolve = () => {}, reject = () => {} } = {} }) {
  try {
    const { response, error } = yield call(USER_API.init2FA)

    if (error) {
      throw error
    }

    resolve(response.data)
  } catch (error) {
    reject(error)
  }
}

export default function* Sagas() {
  yield takeLatest('USER/GET_2FA', get2FA)
  yield takeLatest('USER/ENABLE_2FA', enable2FA)
  yield takeLatest('USER/DISABLE_2FA', disable2FA)
  yield takeLatest('USER/INIT_2FA', init2FA)
}
